import { combineReducers } from '@reduxjs/toolkit';
import dashboardTransactions from './transaction.slice';
import dashboardHelpCenter from './helpcenter.slice';
import dashboardSlice from './dashboard.slice';
import baselineAssesmentSlice from './baseline-assesment.slice';

export const dashboardRootReducer = combineReducers({
    transaction: dashboardTransactions,
    helpCenter: dashboardHelpCenter,
    baselineAssesment: baselineAssesmentSlice,
    dashboard: dashboardSlice,
});
